
import Vue from 'vue';
import { faLink } from '@delfi.lt/fa-kit/icons/modules/classic/light';
import { TranslateResult } from 'vue-i18n';

interface Data {
  visible: boolean;
}

interface Methods {
  shareOrCopyLink: () => Promise<boolean>;
  copyLink: () => boolean;
  showLayer: (text: TranslateResult | string) => void;
}

export default Vue.extend<Data, Methods, unknown, unknown>({
  data() {
    return {
      visible: false,
      faLink,
    };
  },
  methods: {
    async shareOrCopyLink() {
      const isMobileDevice = this.$ua && (this.$ua.isFromSmartphone() || this.$ua.isFromMobilephone() || this.$ua.isFromTablet());

      if (isMobileDevice && navigator.share) {
        try {
          await navigator.share({
            title: document.title,
            url: location.href,
          });
          return true;
        } catch (error) {
          if ((error as DOMException).name === 'AbortError') {
            return false;
          }
        }
      }

      const androidWebAppMobileAPI = (window as { AndroidWebAppMobileAPI?: { sharePage?: (url: string, title: string, text: string) => void } })
        .AndroidWebAppMobileAPI;

      if (isMobileDevice && androidWebAppMobileAPI?.sharePage) {
        androidWebAppMobileAPI.sharePage(location.href, document.title, '');
        return true;
      }

      return this.copyLink();
    },
    copyLink() {
      let textarea;
      let result;
      const string = location.href;
      try {
        textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', 'true');
        textarea.setAttribute('contenteditable', 'true');
        textarea.style.position = 'fixed';
        textarea.value = string;

        document.body.appendChild(textarea);

        textarea.select();

        const range = document.createRange();
        range.selectNodeContents(textarea);

        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);

        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand('copy');
        this.showLayer(this.$t(`info_layer.url_copied`));
      } catch (err) {
        result = null;
      } finally {
        if (textarea) {
          document.body.removeChild(textarea);
        }
      }

      if (!result) {
        const isMac = navigator.platform.toUpperCase().includes('MAC');
        const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        result = prompt(`Press ${copyHotkey}`, string);
        if (!result) {
          return false;
        }
      }
      return true;
    },
    showLayer(text) {
      if (!text) {
        return false;
      }
      const $infoLayer = document.createElement('div');
      $infoLayer.innerHTML = '<span>' + text + '</span>';
      $infoLayer.classList.add('info-layer');
      $infoLayer.style.display = 'block';
      document.body.appendChild($infoLayer);
      setTimeout(function () {
        $infoLayer.style.display = 'none';
        $infoLayer.parentNode?.removeChild($infoLayer);
      }, 2000);
    },
  },
});
